<template>
  <div class="accept-dialog">
    <div class="accept-header">
      <h3 class="accept-title">{{ t('interview.acceptDialogTitle') }}</h3>
      <span class="accept-close" @click="handleClose">×</span>
    </div>
    <div class="accept-content">
      <div class="info-section">
        <div class="info-label">{{ t('interview.candidate') }}</div>
        <div class="info-value">{{ info.candidateName }}</div>
      </div>

      <div class="info-row">
        <div class="info-section">
          <div class="info-label">{{ t('interview.interviewMethod') }}</div>
          <div class="info-value">{{ interviewMethodText }}</div>
        </div>

        <div class="info-section">
          <div class="info-label">{{ t('interview.duration') }}</div>
          <div class="info-value">{{ info.interviewDuration }}{{ t('interview.mins') }}</div>
        </div>
      </div>

      <div class="info-section">
        <div class="info-label">{{ t('interview.interviewTime') }}</div>
        <div class="info-value time-value">{{ formattedInterviewTime }}</div>
      </div>

      <!-- <div v-if="info.interviewUrl" class="info-section">
        <div class="info-label">{{ t('interview.meetingLink') }}</div>
        <a :href="info.interviewUrl" target="_blank" class="info-link">{{ info.interviewUrl }}</a>
      </div> -->

      <div class="info-section">
        <div class="info-label">{{ t('interview.note') }}</div>
        <div class="info-value">{{ info.interviewRemark || '-' }}</div>
      </div>
    </div>
    <div class="accept-footer">
      <el-button class="accept-button accept-button-default" @click="handleCancel">
        {{ t('interview.cancelButton') }}
      </el-button>
      <el-button type="primary" class="accept-button accept-button-primary" @click="handleConfirm">
        {{ t('interview.acceptDialogButton') }}
      </el-button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import type { AcceptDialogProps } from './accept-types';

const { t } = useI18n();

const props = defineProps<AcceptDialogProps>();

const emit = defineEmits<{
  cancel: [];
  confirm: [];
  close: [];
}>();

// 面试方式文本
const interviewMethodText = computed(() => {
  const methodMap: Record<number, string> = {
    1: t('interview.online'),
    2: t('interview.offline'),
  };
  return methodMap[props.info.interviewType] || t('interview.online');
});

// 格式化面试时间
const formattedInterviewTime = computed(() => {
  const info = props.info;

  const date = info.date;
  const startTime = info.startTime;
  const endTime = info.endTime;

  return `${date}(${info.week}) | ${startTime} ~ ${endTime}`;
});

const handleCancel = () => {
  emit('cancel');
};

const handleConfirm = async () => {
  emit('confirm');
};

const handleClose = () => {
  emit('close');
};
</script>

<style lang="scss" scoped>
.accept-dialog {
  min-width: 416px;
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden;
}

.accept-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 30px 30px 20px;
}

.accept-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: #101729;
}

.accept-close {
  font-size: 24px;
  line-height: 1;
  color: #8c8c8c;
  cursor: pointer;
  transition: color 0.3s;

  &:hover {
    color: #262626;
  }
}

.accept-content {
  padding: 0px 30px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.info-row {
  display: flex;
  gap: 16px;

  .info-section {
    flex: 1;
  }
}

.info-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.info-label {
  font-size: 12px;
  line-height: 17px;
  color: #88929B;
}

.info-value {
  font-size: 12px;
  line-height: 17px;
  color: #495057;

  &.time-value {
    color: #009E99;
    font-weight: 500;
    background: #DBF1F1;
    border-radius: 4px;
    height: 29px;
    width: fit-content;
    white-space: nowrap;
    line-height: 29px;
    padding: 0 8px;
  }
}

.info-link {
  font-size: 12px;
  line-height: 17px;
  color: var(--el-color-primary);
  text-decoration: none;
  word-break: break-all;

  &:hover {
    text-decoration: underline;
  }
}

.accept-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 20px 24px 30px;
}

.accept-button {
  min-width: 72px;
  // height: 32px;
  padding: 4px 16px;
  font-size: 14px;
  line-height: 22px;
  // border-radius: 4px;
  // border: 1px solid transparent;
  cursor: pointer;
  transition: all 0.3s;
  outline: none;

  &:active {
    transform: translateY(1px);
  }
}


.accept-button-primary {
  // background: #1677ff;
  color: #ffffff;

  &:hover {
    // background: #4096ff;
  }
}
</style>
